import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ActiveSuppliers } from '../Models/ActiveClasses';
import { AirlineMasterProperties } from '../Models/AirlineMasterProperties';
import { AirportProperties } from '../Models/AirportProperties';
import { TicketSuppliersAccessCodeProperties } from '../Models/GroupTicketProperties';
import { ByAirlinesRateOfExchangeProperties, BySectorRateOfExchangeProperties, LocationByROE, RateOfExchangeProperties, ROEDates, TripType, TypeOfRateOfExchangeFunction } from '../Models/RateOfExchangeProperties';
import { RevenueManagementAirports, Supplier_OficeID } from '../Models/RevenueManagementProperties';
import { AirlineMasterService } from '../Services/airline-master.service';
import { AirportService } from '../Services/airport.service';
import { GroupTicketService } from '../Services/groupTicket.service';
import { RateOfExchangeService } from '../Services/rate-of-exchange.service';
import { RevenueManagementService } from '../Services/revenue-management.service';

@Component({
  selector: 'app-rate-of-exchange',
  templateUrl: './rate-of-exchange.component.html',
  styleUrls: ['./rate-of-exchange.component.css']
})
/** RateOfExchange component*/
export class RateOfExchangeComponent {
  /** RateOfExchange ctor */
  constructor(private groupservice: GroupTicketService, private airportService: AirportService, private revenueService: RevenueManagementService, private service: RateOfExchangeService, private airlineservice: AirlineMasterService, private messageservice: MessageService,
    private router: Router) {

  }
  loader: boolean = false;
  loadermessage: string = "";
  rateofexhcnageenum = new TypeOfRateOfExchangeFunction();
  minDate: string;
  supplierList: ActiveSuppliers[] = [];
  airportProperties: AirportProperties[] = [];
  officeidList: TicketSuppliersAccessCodeProperties[] = [];
  officeidListForBind: TicketSuppliersAccessCodeProperties[] = [];
  rateOfExchangeDetails = new RateOfExchangeProperties();
  rateOfExchangeDetailsExisitINdb: RateOfExchangeProperties[] = [];
  airlineMasterinfo: AirlineMasterProperties[] = [];
  update: boolean = false;
  roeSubmission: boolean = false;
  forRoeCheck: boolean = true;
  officeid: string = "";
  namebutton: string = "";
  currency: string = "";
  ngOnInit() {
   this.currency = localStorage.getItem('AgencyCurrency');
    let roeID = localStorage.getItem("ROEID");
    let typeroe = localStorage.getItem("TypeRoe");
    let agencyid = localStorage.getItem("AgencyId");
    this.getDataAirportAll();
    this.getSuppliers();
    this.GetAirlineData();
    const currentDate = new Date();
    const formattedCurrentDate = currentDate.toISOString().split('T')[0];
    this.minDate = formattedCurrentDate;
    if (typeroe == "Create") {
      this.rateOfExchangeDetails.agencyBranch = agencyid;
      this.namebutton = "Create";
      this.getDataAllROE();

    }
    else if (typeroe == "Update") {
      this.loadermessage = "Loading Please Wait!";
      this.loader = true;

      this.namebutton = "Update";
      this.service.GetRateOFExchangeByID(roeID, localStorage.getItem("AgencyId")).subscribe((data) => {
        this.rateOfExchangeDetails = data;
        this.officeid = data.officeIDs;
        this.changeSupplier();
        this.update = true;
        this.loader = false;
      })
    }
  }
  ParseDate = (dateString: string): string => {
    if (dateString) {
      return dateString;
    }
    return null;
  }
  getDataAllROE() {
    this.service.ROEGetAlls().subscribe((data) => {
      this.rateOfExchangeDetailsExisitINdb = data;

    });
  }
  getDataAirportAll() {
    this.airportService.GetAllAirport().subscribe((data) => {


      this.airportProperties = data;

    });
  }
  getSuppliers() {
    this.revenueService.GetRevenueManagementSupplierByParent(localStorage.getItem("AgencyId")).subscribe((result) => {
      this.supplierList = result;

    });
  }
  supplierAdded: boolean = false;
  changeSupplier() {

    this.officeidListForBind = [];
    this.officeidList = [];
    this.groupservice.GetTicketAccessCode(this.rateOfExchangeDetails.supplier).subscribe(data => {
      this.officeidListForBind = data;

      let curr = localStorage.getItem("AgencyCurrency");
      if (this.officeidListForBind.length > 0) {
        for (let i = this.officeidListForBind.length - 1; i >= 0; i--) {
          if (curr == this.officeidListForBind[i].currencyName) {
            // Remove the item from the array using splice
            this.officeidListForBind.splice(i, 1);
          }
        }
      }

      this.supplierAdded = true;
    });




  }

  AddAirline() {
    if (this.rateOfExchangeDetails.byAirlines == undefined) {
      this.rateOfExchangeDetails.isByAirlines = true;
      this.rateOfExchangeDetails.byAirlines = [];
    }
    let obj = new ByAirlinesRateOfExchangeProperties();
    obj.bySectorList = [];
    obj.airlines = [];
    this.rateOfExchangeDetails.byAirlines.push(obj);
  }
  AddSector(airline) {
    if (this.rateOfExchangeDetails.byAirlines[airline].bySectorList.length == 0) {
      this.rateOfExchangeDetails.byAirlines[airline].isBySector = true;
    }
    let obj = new BySectorRateOfExchangeProperties();
    obj.bookingDate = new ROEDates();
    obj.travelingDate = new ROEDates();
    obj.locationExclusuion = new LocationByROE();
    obj.locationInclusuion = new LocationByROE();
    obj.tripTypes = new TripType();
    this.rateOfExchangeDetails.byAirlines[airline].bySectorList.push(obj);
  }

  deleteSector(airline, sector) {
    if (this.rateOfExchangeDetails.byAirlines[airline].bySectorList.length > 0) {
      if (this.rateOfExchangeDetails.byAirlines[airline].bySectorList[sector].sectorROEID > 0) {

        this.rateOfExchangeDetails.byAirlines[airline].bySectorList[sector].isDeleted = true;

      }
      else {

        this.rateOfExchangeDetails.byAirlines[airline].bySectorList.splice(sector, 1);

      }
    }
    if (this.rateOfExchangeDetails.byAirlines[airline].bySectorList.length == 0) {
      this.rateOfExchangeDetails.byAirlines[airline].isBySector = false;
    }
  }
  deleteairline(airline) {
    if (this.rateOfExchangeDetails.byAirlines.length > 0) {
      if (this.rateOfExchangeDetails.byAirlines[airline].airlineROEID > 0) {

        this.rateOfExchangeDetails.byAirlines[airline].isDeleted = true;

      }
      else {

        this.rateOfExchangeDetails.byAirlines.splice(airline, 1);

      }

    }

    if (this.rateOfExchangeDetails.byAirlines.length == 0) {
      this.rateOfExchangeDetails.isByAirlines = false;
    }
  }
  GetAirlineData() {
    this.airlineservice.getAirlinesData().subscribe((data) => {
      if (data.length > 0) {

        this.airlineMasterinfo = data;
      }
    })
  }
  SubmitData = (roeForm: any): boolean => {
    this.roeSubmission = true;
    if (roeForm.invalid) {
      this.messageservice.add({ severity: 'error', summary: 'Required', detail: 'Fields are Required' });
      return false;
    }
    if (!this.rateOfExchangeRoeCheck(this.rateOfExchangeDetails.byDefaultROE)) {
      return false;
    }

    if (this.rateOfExchangeDetails.isByAirlines) {
      for (let a = 0; a < this.rateOfExchangeDetails.byAirlines.length; a++) {
        if (!this.airlineRoeCheck(this.rateOfExchangeDetails.byAirlines[a].byDefaultROE,a)) {
          return false;
        } else {
          if (this.rateOfExchangeDetails.byAirlines[a].isBySector) {
            for (let s = 0; s < this.rateOfExchangeDetails.byAirlines[a].bySectorList.length; s++) {
              if (!this.sectorRoeCheck(this.rateOfExchangeDetails.byAirlines[a].bySectorList[s].byDefaultROE, a, s)) {
                return false;
              }
            }
          }
        }
      }
    }

    this.loader = true;
    if (this.update) {
      this.loadermessage = "Updating the Data!";
      this.service.UpdateRateOfExchange(this.rateOfExchangeDetails).subscribe((data) => {
        if (data.isSaved) {

          this.messageservice.add({ severity: 'success', summary: 'Success', detail: 'Updated Successfully!' });
          this.router.navigateByUrl("/RateOfExchangeList");

        }
        else {
          this.messageservice.add({ severity: 'error', summary: 'Error', detail: data.errorInfo });
        }
        this.loader = false;
      })
    }
    else {
      if (!this.ChecktheROEExistOrNot()) {
        this.loader = false;
        return false;
      }
      this.loadermessage = "Saving the Data!";
      this.service.CreateRateOfExchange(this.rateOfExchangeDetails).subscribe((data) => {
        if (data.isSaved) {
          this.messageservice.add({ severity: 'success', summary: 'Success', detail: 'Created Successfully!' });
          this.router.navigateByUrl("/RateOfExchangeList");
        }
        else {
          this.messageservice.add({ severity: 'error', summary: 'Error', detail: data.errorInfo });
        }
        this.loader = false;
      })
    }

  }

  sectorchange(airline: number, sector: number, type: number) {
    if (type == this.rateofexhcnageenum.locationInclusion) {
      if (!this.rateOfExchangeDetails.byAirlines[airline].bySectorList[sector].isLocationInclusuion) {
        this.rateOfExchangeDetails.byAirlines[airline].bySectorList[sector].locationInclusuion = new LocationByROE();
      }
    }
    else if (type == this.rateofexhcnageenum.locationExclusion) {
      if (!this.rateOfExchangeDetails.byAirlines[airline].bySectorList[sector].isLocationExclusuion) {
        this.rateOfExchangeDetails.byAirlines[airline].bySectorList[sector].locationExclusuion = new LocationByROE();
      }
    }
    else if (type == this.rateofexhcnageenum.bookingDate) {
      if (!this.rateOfExchangeDetails.byAirlines[airline].bySectorList[sector].isBookingDate) {
        this.rateOfExchangeDetails.byAirlines[airline].bySectorList[sector].bookingDate = new ROEDates();
      }
    }
    else if (type == this.rateofexhcnageenum.travllingDate) {
      if (!this.rateOfExchangeDetails.byAirlines[airline].bySectorList[sector].isTravelDate) {
        this.rateOfExchangeDetails.byAirlines[airline].bySectorList[sector].travelingDate = new ROEDates();
      }
    }
    else if (type == this.rateofexhcnageenum.tripType) {
      if (!this.rateOfExchangeDetails.byAirlines[airline].bySectorList[sector].isTripType) {
        this.rateOfExchangeDetails.byAirlines[airline].bySectorList[sector].tripTypes = new TripType();
      }
    }

  }
  airlinesCheckIfExisit(index: number) {
    for (let o = 0; o < this.rateOfExchangeDetails.byAirlines.length; o++) {
      if (o !== index && !this.rateOfExchangeDetails.byAirlines[o].isDeleted) {
        const otherAirlines = this.rateOfExchangeDetails.byAirlines[o].airlines;
        const selectedAirlines = this.rateOfExchangeDetails.byAirlines[index].airlines;
        if (Array.isArray(otherAirlines) && otherAirlines.every(airline => typeof airline === 'string')) {
          for (let i = 0; i < selectedAirlines.length; i++) {
            const selectedAirline = selectedAirlines[i];
            if (otherAirlines.includes(selectedAirline)) {
              selectedAirlines.splice(i, 1);
              i--;
              this.messageservice.add({ severity: 'warn', summary: 'Warning', detail: "Airline Already Selected!" });
            }
          }
        }
      }
    }

  }

  ChecktheROEExistOrNot(): boolean {

    const index = this.rateOfExchangeDetailsExisitINdb.findIndex(rt =>
      rt.supplier === this.rateOfExchangeDetails.supplier && rt.officeIDs === this.rateOfExchangeDetails.officeIDs
    );

    if (index !== -1) {
      this.messageservice.add({ severity: 'warn', summary: 'Warning', detail: "Against This Supplier or PCC ROE is Exist!.The ROE Name is: " + this.rateOfExchangeDetailsExisitINdb[index].name });
      return false;
    }
    else {
      return true;
    }
  }
  onROEChange(value: number): boolean {

    let check = false;
    if (this.currency  === 'AED') {
      if (value >= 1) {

        this.messageservice.add({ severity: 'error', summary: 'Error', detail: 'Enter value less than 1' });
        check = false;
      } else {
        check = true;

      }
      return check;
    }
    else if (this.currency  === 'PKR') {
      if (value <= 1) {
        this.messageservice.add({ severity: 'error', summary: 'Error', detail: 'Enter value that greater than 1.' });
        check = false;
      } else {
        check = true;

      }

    }
    else if (this.currency === 'SAR') {
      if (value > 1.1) {

        this.messageservice.add({ severity: 'error', summary: 'Error', detail: 'Enter value less than 1.1' });
        check = false;
      } else {
        check = true;

      }
    }

    return check;
  }

  rateOfExchangeRoeCheck(value: number): boolean {
    let check = false;
    if (!this.onROEChange(value)) {
      document.getElementById("rateofexchangeobjroe").innerHTML = "**Invalid Value.";
      check = false;

    }
    else {
      document.getElementById("rateofexchangeobjroe").innerHTML = "";
      check = true;

    }
    return check;
  }
  airlineRoeCheck(value: number, a: number) {
    let check = false;
    if (!this.onROEChange(value)) {
      document.getElementById(`airlineroecheck${a}`).innerHTML = "**Invalid Value.";
      check = false;
    }
    else {
      document.getElementById(`airlineroecheck${a}`).innerHTML = "";
      check = true;
    }
    return check;
  }
  sectorRoeCheck(value: number, a: number, s: number) {
    let check = false;
    if (!this.onROEChange(value)) {
      document.getElementById(`sectorroecheck${a}${s}`).innerHTML = "**Invalid Value.";
      check = false;
    }
    else {
      document.getElementById(`sectorroecheck${a}${s}`).innerHTML = "";
      check = true;
    }
    return check;
  }

  validatePositiveNumber(event: any) {
    const value = event.target.value;
    if (value < 0) {
      event.target.value = '';
      this.messageservice.add({ severity: 'error', summary: 'Error', detail: 'Enter positive number.' });
    }
  }
}
